import { request } from "../../apis";
import { getUserCurrency } from "../../plugins/utils";

const userCurrency = getUserCurrency();

export const apiGetPromoActiveUser = (params) =>
  request("get", `/${userCurrency}/agent/promotion/active/user`, params, true);

export const apiApplyPromotion = (params) =>
  request("put", `/${userCurrency}/agent/promotion/bonus/apply`, params, true);

export const apiGetExtraBonusRecord = (params) =>
  request("get", `/${userCurrency}/agent/promotion/extra/bonus/record`, params, true);

export const apiReceiveExtraBonus = (level) =>
  request("put", `/${userCurrency}/agent/promotion/extra/bonus/${level}/receive`, {}, true);

export const apiPromoActiveSetting = () =>
  request("get", `/${userCurrency}/agent/promotion/active/setting`, {}, true);
